export default __webpack_public_path__ + "static/media/Next.846e8544.png";